import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo" role="group" aria-label="Lummo">
              <img src="/brand/__Logo_negro.png" alt="" className="footer-logo__img" />
            </div>
            <p className="footer-tagline">
              AI-native clinical trial infrastructure for LATAM
            </p>
          </div>
          
          <div className="footer-links">
            <div className="link-group">
              <h4>Solutions</h4>
              <Link to="/solution/cro">CRO</Link>
              <Link to="/solution/sites">Sites</Link>
              <Link to="/solution/patients">Patients</Link>
            </div>
            
            <div className="link-group">
              <h4>Company</h4>
              <Link to="/team">Team</Link>
              <Link to="/contact">Contact</Link>
            </div>
            
            <div className="link-group">
              <h4>Connect</h4>
              <a href="mailto:hello@lummo.io">hello@lummo.io</a>
              <a href="https://linkedin.com/company/lummo-io" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; 2024 Lummo. All rights reserved.</p>
          </div>
          <div className="footer-legal">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
